import ViewUsersGrid from './ViewUsersGrid';

export default ViewUsersGrid;



// WEBPACK FOOTER //
// ./src/components/grids/ViewUsersGrid/index.jsx